export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const OTP_RESEND_TIME = 60;
export const RUPEE_SYMBOL = "₹";
